export const PASS_VALIDATE_EMAIL = "PASS_VALIDATE_EMAIL";
export const passValidateEmail = (email, securityQuestion) => ({
  type: PASS_VALIDATE_EMAIL,
  email,
  securityQuestion,
});

export const VALIDATE_BEGIN = "VALIDATE_BEGIN";
export const validateBegin = (email, code) => ({
  type: VALIDATE_BEGIN,
  email,
  code,
});

export const VALIDATE_SUCCESS = "VALIDATE_SUCCESS";
export const validateSuccess = () => ({
  type: VALIDATE_SUCCESS,
});

export const VALIDATE_FAILURE = "VALIDATE_FAILURE";
export const validateFailure = () => ({
  type: VALIDATE_FAILURE,
});
